
// 根据数据层级返回匹配下标数组（给门店三级联动反绑数据用）
/**
 * 
 * @param {级联数据} data 
 * @param {匹配的数据} targetId 
 * @returns 
 */
const findIndexArray = (data, targetId) => {
    // 递归查找匹配 id 的索引路径
    const findIndexPath = (data, targetId) => {
        for (let i = 0; i < data.length; i++) {
            if (data[i].id === targetId) {
                return [i];
            }
            if (data[i].children && data[i].children.length) {
                const childPath = findIndexPath(data[i].children, targetId);
                if (childPath) {
                    return [i, ...childPath];
                }
            }
        }
        return null;
    }
    // 获取数据层级深度
    const getDataDepth = (data) => {
        if (!data || !data.length || !data[0].children) {
            return 1;
        }
        return 1 + getDataDepth(data[0].children);
    }

    // 获取数据实际层级
    const depth = getDataDepth(data);

    // 查找匹配的索引路径
    const indexPath = findIndexPath(data, targetId);

    if (indexPath) {
        // 确保返回的数组长度与实际层级相同
        while (indexPath.length < depth) {
            indexPath.push(0);
        }
        return indexPath;
    }

    // 根据实际层级返回对应长度的默认值数组
    return new Array(depth).fill(0);
}
export {
    findIndexArray
}